// Página de pago pendiente en Mercado Pago
// Muestra mensaje de pago en proceso y redirige al radar

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaClock } from 'react-icons/fa';

/**
 * Componente EcommercePending
 * Muestra mensaje de pago pendiente después de iniciar el proceso en Mercado Pago
 */
const EcommercePending = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir al radar después de 3 segundos
    const timer = setTimeout(() => {
      navigate('/radar');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900 px-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-yellow-100 dark:bg-yellow-900 rounded-full p-4">
            <FaClock className="w-12 h-12 text-yellow-600 dark:text-yellow-400" />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Pago Pendiente
        </h1>
        
        <p className="text-gray-600 dark:text-gray-300 mb-6">
          Tu pago está siendo procesado. Serás notificado cuando se complete. Serás redirigido al radar en unos segundos.
        </p>
        
        <button
          onClick={() => navigate('/radar')}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
        >
          Ir al Radar
        </button>
      </div>
    </div>
  );
};

export default EcommercePending;
